import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { IBaseSearchFormSchema } from '~/purchase/types';

// Express quote only. Higher indexes only apply to dimension searches: a
// reference (EAN, …) search unchecks and locks the box, as the backend ignores
// it there anyway. Back on a dimension search, the box returns to the form
// default, i.e. the point of sale quote setting.
export const useIncludeHigherIndexes = ({ express }: { express: boolean }) => {
  const { control, setValue, formState } =
    useFormContext<IBaseSearchFormSchema>();
  const [vehicleTypeGroup, identifier] = useWatch({
    control,
    name: ['vehicleTypeGroup', 'identifier'],
  });
  const isReferenceSearch = express && Boolean(identifier?.value);
  const defaultChecked = Boolean(formState.defaultValues?.includeHigherIndexes);

  useEffect(() => {
    if (!express) {
      return;
    }
    setValue('includeHigherIndexes', !isReferenceSearch && defaultChecked);
  }, [express, isReferenceSearch, defaultChecked, setValue]);

  return { disabled: !vehicleTypeGroup || isReferenceSearch };
};
